import { IBestOfYearStatusResponse } from 'app/components/BannerHandler/hooks/useBestOfYearStatus';
import { IBestOf2025Response } from 'app/components/BestOf2025/hooks/useBestOf2025';
import { IBestOf2025VotingResponse } from 'app/components/BestOf2025/hooks/useBestOf2025Voting';

import { http } from './http';

export const getBestOfYears = (year: number) => {
  return http.get<IBestOf2025Response>(`best_of_years/${year}`);
};

export const getBestOfYearsVotingIndex = (year: number) => {
  return http.get<IBestOf2025VotingResponse>(`best_of_years/${year}/voting_index`);
};

export const getBestOfYearsWinners = (year: number, view?: string) => {
  return http.get(`best_of_years/${year}/winners`, { view });
};

export const postBestOfYearsPersistWinners = (year: number) => {
  return http.post(`best_of_years/${year}/persist_winners`);
};

export const putBestOfYearsVote = (
  year: number,
  resourceUuid: string | string[],
  switch_vote: boolean = false
) => {
  return http.put(`best_of_years/${year}/vote`, {
    resource_uuid: resourceUuid,
    switch: switch_vote,
  });
};

export const deleteBestOfYearsVote = (year: number, resourceUuid: string | string[]) => {
  return http.delete(`best_of_years/${year}/vote`, { resource_uuid: resourceUuid });
};

export const getBestOfYearsStatus = (year: number) => {
  return http.get<IBestOfYearStatusResponse>(`best_of_years/${year}/status`);
};
